import { render, staticRenderFns } from "./EmptyImage.vue?vue&type=template&id=6ca7cadc&scoped=true"
import script from "./EmptyImage.vue?vue&type=script&lang=js"
export * from "./EmptyImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7cadc",
  null
  
)

export default component.exports